import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Toponym } from '../../../models/toponym.model';
import { ToponymService } from './../../../services/toponym/toponym.service';

@Component({
  selector: 'app-toponym-form',
  templateUrl: 'toponymForm.component.html',
  styles: ['label.required:after {top: 0}']
})

export class ToponymFormComponent implements OnInit {
  @Output() toponymAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() toponymUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxToponym: Toponym;
  addEditForm: FormGroup;
  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private toponymService: ToponymService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.toponymService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditForm = this.fb.group({
      'name': new FormControl(this.dialogBoxToponym.name)
    });
  }

  saveOrUpdate(dialogBox: any): void {
    // console.log('request to insert or update language');
    // console.log(this.dialogBoxToponym);

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxToponym, this.addEditForm.value);
    if (newData.id == null) {
      this.toponymAdded.emit(newData);
    } else {
      this.toponymUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/toponym/toponymForm.component.ts